import { render } from "./MenuField.vue?vue&type=template&id=41db6164"
import script from "./MenuField.vue?vue&type=script&lang=js"
export * from "./MenuField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__